import Player from "./player/Player";
import {IPlayer, PlayerState} from "../types";
import React from "react";

interface Props {
    playersInGame: IPlayer[];
}

const PlayersInGame = ({ playersInGame }: Props) => {
    const players = playersInGame.map(player => {
        const orderClass = player.state === PlayerState.ACTIVE ? "max-md:order-first w-full" : "order-none";
        return <li key={player.id} className={`flex flex-col ${orderClass} items-center justify-start w-[150px] md:w-[240px] h-auto`}>
            <Player player={player} hideActions={true} />
        </li>;
    });

    return (
        <ul className="flex flex-wrap items-start gap-x-[8px] gap-y-[12px] md:gap-x-[54px] md:gap-y-[35px] mx-auto mb-[36px] w-full place-content-center ">
            {players}
        </ul>
    );
}

export default PlayersInGame;
